export default "__VITE_ASSET__c7d8f4c1__"